// 45be085d06f2b331b038fb65c016444f3a7ecebd|kind=api-js|className=CurrencyApi|type=angular|apiName=am|apiEnumKey=AM|operationHash=344b6cb5079603014518f41ba39f8727c49dfc83

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';

import { parseOkResponseWrappingCurrencyListFromJSON } from '../../../parsers/OkResponseWrappingCurrencyList';

export class CurrencyApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @tags CurrencyApi
   * @name CurrencyApiGetAllCurrencies
   * @request GET:/currencies
   */
  getAllCurrencies(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/currencies`,
        method: 'GET',
        api: Api.AM,
      },
      {
        ...requestOptions,
        parser: parseOkResponseWrappingCurrencyListFromJSON,
      },
    );
  }

  static ɵfac = function CurrencyApi_Factory(t) { return new (t || CurrencyApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: CurrencyApi, factory: CurrencyApi.ɵfac, providedIn: 'root' });
}
